import axios from 'axios'

export default {
  state: {
    screencasts_list: [],
    screencasts_categories: [],
  },
  getters: {
    getScreencastsList: (s) => s.screencasts_list,
    getScreencastsCategories: (s) => s.screencasts_categories,
  },
  mutations: {
    setScreencastsList: (s, list) =>
      (s.screencasts_list = list.filter((el) => el.translates.length)),
    setScreencastsCategories: (s, list) =>
      (s.screencasts_categories = list.filter((el) => el.translates.length)),
  },
  actions: {
    fetchScreencastsList(ctx, { lang = 'ru', category_name, intensive_slug }) {
      let category = category_name ? `&category_slug=${category_name}` : ''
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/intensives/screencasts/?language=${lang}${category}&intensive_slug=${intensive_slug}`,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setScreencastsList', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    clearScreencastsList(ctx) {
      ctx.commit('setScreencastsList', [])
    },
    fetchScreencastsCategories(ctx) {
      return axios({
        method: 'GET',
        url: `api/v3/intensives/screencasts/categories/`,
      })
        .then((response) => {
          const list = response.data
          ctx.commit('setScreencastsCategories', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    ScreencastsSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/intensives/screencasts/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    ScreencastsSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/screencasts/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    ScreencastsSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/screencasts/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    ScreencastsSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/screencasts/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
